import { Container, Grid, Card, Box } from "@mui/material";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import PublicNavbar from "../../../devComponents/Navbars/PublicNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import footerRoutes from "footer.routes";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../Home/sections/Download";
import ConsultationForm from "../../ConsultationProgram/ConsultationForm";
import L1 from "../../../assets/images/caseStudies/lightning/L1.png";
import L2 from "../../../assets/images/caseStudies/lightning/L2.png";
import L3 from "../../../assets/images/caseStudies/lightning/L3.png";
import L8 from "../../../assets/images/caseStudies/lightning/L8.png";
import L7 from "../../../assets/images/caseStudies/lightning/L7.png";
import L6 from "../../../assets/images/caseStudies/lightning/L6.png";
import L10 from "../../../assets/images/caseStudies/lightning/L10.png";
function LightningCaseStudy() {
  const navigate = useNavigate();
  const [consultOpen, setConsultOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <MKBox sx={{ background: "#f8f9fa" }}>
      <PublicNavbar />

      {/* Hero Section */}
      <MKBox
        minHeight="35vh"
        width="100%"
        sx={{
          background: "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          pt: { xs: 15, md: 17 },
          mt: "-80px",
        }}
      >
        <Container>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <MKTypography
                variant="h1"
                color="white"
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: "2rem", md: "3rem" },
                  textShadow: "2px 4px 8px rgba(0,0,0,0.3)",
                  mb: 2,
                  textAlign: "center",
                }}
              >
                LightningOS Case Study
              </MKTypography>
              <MKTypography
                variant="h4"
                color="white"
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: "1.25rem", md: "1.75rem" },
                  textShadow: "1px 2px 4px rgba(0,0,0,0.2)",
                  opacity: 0.95,
                  mb: 3,
                  textAlign: "center",
                }}
              >
                From Fragmented Operations to Multi-State Scale
              </MKTypography>
              <MKTypography
                variant="h6"
                color="white"
                sx={{
                  fontWeight: 400,
                  opacity: 0.9,
                  textShadow: "1px 2px 4px rgba(0,0,0,0.2)",
                  textAlign: "center",
                }}
              >
                How Lightning Became a Sales Powerhouse with LightningOS
              </MKTypography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                component="img"
                src={L10}
                alt="Lightning OS"
                sx={{
                  width: "100%",
                  borderRadius: 4,
                }}
              />
            </Grid>
          </Grid>
        </Container>
      </MKBox>

      <Container sx={{ mt: { xs: 3, md: 6 }, mb: 10 }}>
        {/* Back Button */}
        <Box sx={{ mb: 4 }}>
          <MKButton
            variant="text"
            color="dark"
            onClick={() => navigate("/case-studies")}
            sx={{ pl: 0, color: "#0b1020", fontWeight: 600 }}
          >
            ← Back to Case Studies
          </MKButton>
        </Box>

        {/* Introduction */}
        <Card
          sx={{
            p: { xs: 3, md: 6 },
            mb: 4,
            borderRadius: 4,
            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
          }}
        >
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={8}>
              <MKTypography
                variant="body1"
                sx={{
                  color: "#7b809a",
                  lineHeight: 1.8,
                  fontSize: "1.15rem",
                  fontWeight: 500,
                }}
              >
                Lightning transitioned from disconnected tools and unreliable
                fiber-company reporting to full operational visibility,
                eliminating revenue leaks, enforcing commission accuracy, and
                unlocking new growth channels through LightningOS.
              </MKTypography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box
                component="img"
                src={L3}
                alt="Lightning overview"
                sx={{ width: "100%" }}
              />
            </Grid>
          </Grid>
        </Card>

        {/* About Lightning */}
        <Card
          sx={{
            p: { xs: 3, md: 6 },
            mb: 4,
            borderRadius: 4,
            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
          }}
        >
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={8}>
              <MKTypography
                variant="h3"
                sx={{ fontWeight: 600, mb: 3, color: "#344767" }}
              >
                About Lightning
              </MKTypography>
              <MKTypography
                variant="body1"
                sx={{
                  color: "#7b809a",
                  lineHeight: 1.8,
                  fontSize: "1.1rem",
                  mb: 2,
                }}
              >
                Lightning is a U.S.-based sales agency specializing in fiber and
                telecom sales, operating across multiple states with a large,
                fast-moving sales force.
              </MKTypography>
              <MKTypography
                variant="body1"
                sx={{ color: "#7b809a", lineHeight: 1.8, fontSize: "1.1rem" }}
              >
                The business runs on high-frequency transactions, constant rep
                onboarding, and complex commission structures, a model that
                demands speed, accuracy, and absolute trust in reporting. As
                Lightning scaled, the need for a system that could provide
                real-time clarity and operational truth became critical.
              </MKTypography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box
                component="img"
                src={L1}
                alt="About Lightning"
                sx={{ width: "100%" }}
              />
            </Grid>
          </Grid>
        </Card>

        {/* Challenges */}
        <Card
          sx={{
            p: { xs: 3, md: 6 },
            mb: 4,
            borderRadius: 4,
            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
          }}
        >
          <Grid container spacing={4} alignItems="flex-start">
            <Grid item xs={12} md={8}>
              <MKTypography
                variant="h3"
                sx={{ fontWeight: 600, mb: 3, color: "#344767" }}
              >
                Challenges Before LightningOS
              </MKTypography>
              <MKTypography
                variant="body1"
                sx={{
                  color: "#7b809a",
                  lineHeight: 1.8,
                  fontSize: "1.1rem",
                  mb: 3,
                }}
              >
                Before LightningOS, Lightning's operations were constrained by
                fragmentation and limited visibility.
              </MKTypography>
              <MKTypography
                variant="h6"
                sx={{ fontWeight: 600, color: "#344767", mb: 2 }}
              >
                Key challenges included:
              </MKTypography>
              <Box
                component="ul"
                sx={{
                  color: "#7b809a",
                  lineHeight: 2,
                  pl: 3,
                  fontSize: "1.05rem",
                }}
              >
                <li>
                  No real-time visibility into account statuses reported by
                  fiber companies
                </li>
                <li>
                  Frequent under-reporting or missing accounts with no reliable
                  way to verify them
                </li>
                <li>
                  Heavy administrative workload to reconcile sales, commissions,
                  and payouts
                </li>
                <li>
                  No unified system to track:
                  <ul style={{ marginTop: "8px" }}>
                    <li>Sales representatives</li>
                    <li>Commissions and pay rules</li>
                    <li>Service addresses</li>
                    <li>Multi-state deployments</li>
                  </ul>
                </li>
                <li>
                  Revenue loss due to misalignment between internal records and
                  ISP reporting
                </li>
                <li>
                  Manual processes that made scaling teams slow and error-prone
                </li>
                <li>
                  No clearly defined lead lifecycle from acquisition to
                  activation
                </li>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box
                component="img"
                src={L2}
                alt="Challenges"
                sx={{ width: "100%" }}
              />
            </Grid>
          </Grid>
          <MKTypography
            variant="body1"
            sx={{
              color: "#7b809a",
              lineHeight: 1.8,
              fontSize: "1.1rem",
              mt: 3,
            }}
          >
            These limitations not only slowed operations, they directly impacted
            revenue and growth potential.
          </MKTypography>
        </Card>

        {/* The Solution */}
        <Card
          sx={{
            p: { xs: 3, md: 6 },
            mb: 4,
            borderRadius: 4,
            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
          }}
        >
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={8}>
              <MKTypography
                variant="h3"
                sx={{ fontWeight: 600, mb: 3, color: "#344767" }}
              >
                The LightningOS Solution
              </MKTypography>
              <MKTypography
                variant="body1"
                sx={{
                  color: "#7b809a",
                  lineHeight: 1.8,
                  fontSize: "1.1rem",
                  mb: 4,
                }}
              >
                LightningOS was deployed as the central operating system for
                Lightning's entire sales operation.
              </MKTypography>

              {/* Core Impact Areas */}
              <Box sx={{ mb: 4 }}>
                <MKTypography
                  variant="h5"
                  sx={{
                    fontWeight: 600,
                    mb: 2,
                    color: "#344767",
                    fontSize: "1.3rem",
                  }}
                >
                  Core Impact Areas
                </MKTypography>
                <Box
                  component="ul"
                  sx={{
                    color: "#7b809a",
                    lineHeight: 2,
                    pl: 3,
                    fontSize: "1.05rem",
                  }}
                >
                  <li>
                    <strong>Lead Lifecycle Management:</strong> End-to-end
                    tracking from lead intake to activation
                  </li>
                  <li>
                    <strong>Real-Time Visibility:</strong> Instant insight into
                    account status across all teams
                  </li>
                  <li>
                    <strong>Geo-Mapped Territories:</strong> Clear routing and
                    deployment across multi-state regions
                  </li>
                  <li>
                    <strong>Role-Based Access:</strong> Controlled views for
                    reps, managers, and leadership
                  </li>
                  <li>
                    <strong>Multi-Tenant Control:</strong> Oversight of multiple
                    teams and partner agencies
                  </li>
                  <li>
                    <strong>Dynamic Pay Rules & Commission Automation:</strong>{" "}
                    Accurate, automated payouts
                  </li>
                  <li>
                    <strong>Instant Account Status Sync:</strong> Live
                    validation against ISP reporting
                  </li>
                  <li>
                    <strong>Advanced Reporting:</strong> Clear, actionable
                    insights for leadership
                  </li>
                  <li>
                    <strong>Internal Communication Tools:</strong> Centralized
                    coordination across teams
                  </li>
                  <li>
                    <strong>White-Labeled Platform:</strong> Partner agencies
                    operating under LightningOS
                  </li>
                </Box>
              </Box>

              {/* Financial Impact */}
              <Box sx={{ mb: 4 }}>
                <MKTypography
                  variant="h5"
                  sx={{
                    fontWeight: 600,
                    mb: 2,
                    color: "#344767",
                    fontSize: "1.3rem",
                  }}
                >
                  Financial Impact Capabilities
                </MKTypography>
                <Box
                  component="ul"
                  sx={{
                    color: "#7b809a",
                    lineHeight: 2,
                    pl: 3,
                    fontSize: "1.05rem",
                  }}
                >
                  <li>
                    Automatic detection of missing or under-reported accounts
                  </li>
                  <li>
                    Prevention of lost commissions through verified reporting
                  </li>
                  <li>Enforcement of multi-agency revenue-sharing rules</li>
                  <li>
                    New revenue streams generated from partner agencies using
                    LightningOS
                  </li>
                </Box>
              </Box>

              {/* Operational Impact */}
              <Box>
                <MKTypography
                  variant="h5"
                  sx={{
                    fontWeight: 600,
                    mb: 2,
                    color: "#344767",
                    fontSize: "1.3rem",
                  }}
                >
                  Operational Impact Capabilities
                </MKTypography>
                <Box
                  component="ul"
                  sx={{
                    color: "#7b809a",
                    lineHeight: 2,
                    pl: 3,
                    fontSize: "1.05rem",
                  }}
                >
                  <li>Faster onboarding of new representatives</li>
                  <li>Centralized communication and task coordination</li>
                  <li>Optimized scheduling and territory assignments</li>
                  <li>Custom workflows tailored to different fiber ISPs</li>
                </Box>
              </Box>

              <MKTypography
                variant="body1"
                sx={{
                  color: "#7b809a",
                  lineHeight: 1.8,
                  fontSize: "1.1rem",
                  mt: 4,
                }}
              >
                LightningOS didn't just support operations, it redefined how
                Lightning scaled.
              </MKTypography>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box
                component="img"
                src={L8}
                alt="Lightning solution"
                sx={{ width: "100%" }}
              />
            </Grid>
          </Grid>
        </Card>

        {/* Results */}
        <Card
          sx={{
            p: { xs: 3, md: 6 },
            mb: 4,
            borderRadius: 4,
            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
          }}
        >
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={8}>
              <MKTypography
                variant="h3"
                sx={{ fontWeight: 600, mb: 3, color: "#344767" }}
              >
                Results After LightningOS
              </MKTypography>
              <MKTypography
                variant="body1"
                sx={{
                  color: "#7b809a",
                  lineHeight: 1.8,
                  fontSize: "1.1rem",
                  mb: 3,
                }}
              >
                LightningOS became the backbone of Lightning's entire operation.
              </MKTypography>
              <MKTypography
                variant="h6"
                sx={{ fontWeight: 600, color: "#344767", mb: 2 }}
              >
                As a result:
              </MKTypography>
              <Box
                component="ul"
                sx={{
                  color: "#7b809a",
                  lineHeight: 2,
                  pl: 3,
                  fontSize: "1.05rem",
                }}
              >
                <li>Lightning successfully expanded into multiple states</li>
                <li>
                  Revenue and commission structures scaled with accuracy and
                  control
                </li>
                <li>
                  Revenue loss from missing or misreported accounts dropped
                  dramatically
                </li>
                <li>
                  Leadership gained full visibility into every rep, lead, and
                  account
                </li>
                <li>
                  Negotiation power with ISPs increased due to reliable,
                  real-time data
                </li>
                <li>
                  Partner agencies adopted the platform, creating additional
                  revenue channels
                </li>
                <li>Operational confidence replaced guesswork</li>
              </Box>
              <MKTypography
                variant="body1"
                sx={{
                  color: "#7b809a",
                  lineHeight: 1.8,
                  fontSize: "1.1rem",
                  mt: 3,
                }}
              >
                Lightning moved from reactive operations to controlled,
                data-driven scale.
              </MKTypography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box
                component="img"
                src={L7}
                alt="Lightning results"
                sx={{ width: "100%" }}
              />
            </Grid>
          </Grid>
        </Card>

        {/* Closing */}
        <Card
          sx={{
            p: { xs: 4, md: 6 },
            borderRadius: 4,
            background: "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)",
            textAlign: "center",
            boxShadow: "0 8px 32px rgba(240, 147, 251, 0.4)",
          }}
        >
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={8}>
              <MKTypography
                variant="h4"
                color="white"
                sx={{
                  fontWeight: 600,
                  mb: 2,
                  textShadow: "1px 2px 4px rgba(0,0,0,0.2)",
                }}
              >
                Ready to Scale Your Sales Operations?
              </MKTypography>
              <MKTypography
                variant="body1"
                color="white"
                sx={{
                  lineHeight: 1.8,
                  fontSize: "1.1rem",
                  mb: 3,
                  opacity: 0.95,
                  textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
                }}
              >
                LightningOS is built for high-volume fiber and telecom sales
                operations that demand accuracy, automation, and scale. If your
                business runs on reps, leads, and commissions, LightningOS
                becomes your operating system.
              </MKTypography>
              <MKButton
                variant="contained"
                onClick={() => setConsultOpen(true)}
                sx={{
                  px: 4,
                  py: 1.5,
                  fontSize: "1rem",
                  fontWeight: 700,
                  background: "linear-gradient(135deg,#0b1020 0%,#2b0057 90%)",
                  color: "#fff",
                  "&:hover": { boxShadow: "0 10px 30px rgba(43,0,87,0.45)" },
                }}
              >
                Talk to Us
              </MKButton>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box
                component="img"
                src={L6}
                alt="Ready to scale"
                sx={{ width: "100%" }}
              />
            </Grid>
          </Grid>
        </Card>
      </Container>

      {consultOpen && (
        <MKBox
          onClick={() => setConsultOpen(false)}
          sx={{
            position: "fixed",
            inset: 0,
            zIndex: 1300,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0,0,0,0.5)",
            backdropFilter: "blur(3px)",
            overflow: "hidden",
            overscrollBehavior: "none",
            p: 2,
          }}
        >
          <Box
            onClick={(e) => e.stopPropagation()}
            sx={{
              width: { xs: "100%", md: "800px" },
              height: { xs: "75vh", md: "80vh" },
              position: "relative",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <ConsultationForm isModal onClose={() => setConsultOpen(false)} />
          </Box>
        </MKBox>
      )}

      <Footer />
    </MKBox>
  );
}

export default LightningCaseStudy;
